import type { TextFieldElementProps } from 'react-hook-form-mui';
import { TextFieldElement } from 'react-hook-form-mui';

import { translateErrorMessage } from 'Common/Form/FormConsts';
import { useSelectUserTheme } from 'User/data';

type Props = TextFieldElementProps & {
  type?: string;
  name: string;
  label?: string;
  isRequired?: boolean;
};

export const TextField = ({ type, name, label, isRequired, ...props }: Readonly<Props>) => {
  const currentTheme = useSelectUserTheme();

  return (
    <TextFieldElement
      {...props}
      type={type ?? 'text'}
      name={name}
      label={label}
      autoComplete={label}
      required={isRequired}
      parseError={translateErrorMessage}
      slotProps={{
        htmlInput: { currentTheme }
      }}
    />
  );
};
